/* ────────────────────────────────────────────────────────────────────────────
   Shared merge-token catalogue for the in-app inserter popovers.

   Used by both the template builder (per-block text inputs) and the
   campaign sequence editor (subject + body fields). Listing them in one
   place keeps the two surfaces in sync.

   These are the tokens the system auto-resolves at send time (recipient +
   recruiter + company + calendar) plus the canonical "every email needs
   one" tokens (calendar_url, unsubscribe_url) and the most common job
   sub-tokens. Anything more exotic is collected via the campaign-builder
   "Template inputs" form (Sprint 16b) — not via the inserter.
   ──────────────────────────────────────────────────────────────────────── */

export const COMMON_MERGE_TOKENS: readonly string[] = [
  // Recipient
  'first_name',
  'last_name',
  'full_name',
  'last_role',
  'last_company',
  // Job (resolved automatically when a campaign has bound_job_id — Sprint 16c)
  'job.title',
  'job.location',
  'job.summary',
  'job.salary',
  'job.url',
  // Recruiter (from UsersCache — Sprint 16a)
  'recruiter.full_name',
  'recruiter.title',
  'recruiter.phone',
  // Company (from BrandKit — Sprint 16a)
  'company.name',
  'company.address',
  // CTA links (resolved from the default BookingLink / unsubscribe surface)
  'calendar_url',
  'unsubscribe_url',
];

/** Tags a TASK step's title resolves (workflow-engine handleTaskStep's merge data). JT1-1911. */
export const TASK_MERGE_TOKENS: readonly string[] = [
  'first_name',
  'last_name',
  'email',
  'company',
  'title',
  'campaign_name',
  'previous_email_subject',
  'profile_url',
  'calendar_link',
];

/** Tags an SMS step's body resolves (sms-send.service's merge data). JT1-1911. */
export const SMS_MERGE_TOKENS: readonly string[] = ['first_name', 'last_name', 'full_name', 'company', 'title'];
